export default __webpack_public_path__ + "static/media/emoji_exercises.53688b0c.svg";